export const staticFooterData = {
  shoppersdrugmart: {
    en: {
      signUp: {
        info: {
          title: "Sign up and get 10,000 PC Optimum™ points",
          details:
            "Sign up for emails and text offers and get points to use on your next purchase of $40+!",
        },
        cta: {
          displayName: "Sign up",
          url: "https://www.shoppersdrugmart.ca/page/sign-up",
        },
      },
      downloadApp: {
        title: "Shoppers Drug Mart App",
        appStore: {
          url: "https://apps.apple.com/ca/app/shoppers-drug-mart/id1460588916",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/apple-app-store.svg",
          alt: "Download on the App Store",
        },
        googlePlay: {
          url: "https://play.google.com/store/apps/details?id=com.loblaw.shoppersdrugmart",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/google-play.svg",
          alt: "Get it on Google Play",
        },
      },
      socialMediaIcons: [
        {
          name: "facebook",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/facebook.svg",
          alt: "facebook icon",
          url: "https://www.facebook.com/shoppersdrugmart",
        },
        {
          name: "instagram",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/instagram.svg",
          alt: "instagram icon",
          url: "https://www.instagram.com/shoppersdrugmart/",
        },
        {
          name: "pinterest",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/pinterest.svg",
          alt: "pinterest icon",
          url: "https://www.pinterest.ca/shoppersdrugmart/",
        },
        {
          name: "tiktok",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/tiktok.svg",
          alt: "tiktok icon",
          url: "https://www.tiktok.com/@shoppersdrugmart",
        },
        {
          name: "twitter",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/twitter.svg",
          alt: "twitter icon",
          url: "https://twitter.com/ShopprsDrugMart",
        },
        {
          name: "youtube",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/youtube.svg",
          alt: "youtube icon",
          url: "https://www.youtube.com/user/ShoppersDrugMartTV",
        },
      ],
      siteMapLinks: [
        {
          title: "FAQ",
          categories: [
            {
              text: "Online Shopping",
              url: "https://lclcallcenters.my.site.com/shoppersdrugmart/s/topic/0TO2M000001FlqEWAS/online-shopping-services?language=en_US",
            },

            {
              text: "PC Optimum™",
              url: "https://lclcallcenters.my.site.com/PCoptimumsupport/s/?language=en_US",
            },
            {
              text: "My Health Dashboard",
              url: "https://www.shoppersdrugmart.ca/health/my-health-dashboard?lang=en",
            },
            {
              text: "Other FAQ",
              url: "https://lclcallcenters.my.site.com/shoppersdrugmart/s/?language=en_US",
            },
          ],
        },
        {
          title: "Customer Service",
          categories: [
            {
              text: "Contact Us",
              url: "https://www.shoppersdrugmart.ca/page/contact-us",
            },
            {
              text: "Find a Store",
              url: "https://www.shoppersdrugmart.ca/en/store-locator",
            },
            {
              text: "Returns & Exchanges",
              url: "https://www.shoppersdrugmart.ca/page/returns-and-exchanges",
            },
            {
              text: "Shipping & Handling",
              url: "https://www.shoppersdrugmart.ca/page/shipping-and-handling",
            },
            {
              text: "Same-day Delivery ",
              url: "https://www.shoppersdrugmart.ca/page/same-day-delivery",
            },
            {
              text: "Online Pick-Up",
              url: "https://www.shoppersdrugmart.ca/page/OnlinePickUp",
            },
          ],
        },
        {
          title: "Corporate",
          categories: [
            {
              text: `Shoppers Foundation for Women’s Health™`,
              url: "https://shoppersfoundation.ca/",
            },

            {
              text: "Corporate",
              url: "https://corporate.shoppersdrugmart.ca/en/home",
            },
            {
              text: "Corporate News",
              url: "https://corporate.shoppersdrugmart.ca/en/our-stories",
            },
            {
              text: "Franchise Opportunities",
              url: "https://corporate.shoppersdrugmart.ca/en/careers-franchise",
            },
            {
              text: "Pharmacy Acquisitions",
              url: "https://corporate.shoppersdrugmart.ca/en/careers-sell-to-us",
            },
            {
              text: "Careers",
              url: "https://corporate.shoppersdrugmart.ca/en/careers-life-at-shoppers",
            },
          ],
        },
        {
          title: "More by Shoppers",
          categories: [
            {
              text: "Check Gift Card Balance",
              url: "https://wbiprod.storedvalue.com/wbir/clients/shoppersdrugmart?lng=en",
            },
            {
              text: "PC Health™",
              url: "https://www.pchealth.ca/en/",
            },
            {
              text: "Shoppers Photo",
              url: "https://www.shoppersphoto.ca/",
            },
            {
              text: "Passport Photos",
              url: "https://www.shoppersdrugmart.ca/en/more-by-shoppers/passport",
            },
            {
              text: "Fresh Food",
              url: "https://www.shoppersdrugmart.ca/en/more-by-shoppers/fresh-food",
            },
            {
              text: "PRESTO",
              url: "https://www.shoppersdrugmart.ca/en/presto",
            },
          ],
        },
      ],
      utilityLinks: [
        {
          text: "Français",
          url: "https://www.shoppersdrugmart.ca/fr/home",
        },
        {
          text: "Accessibility",
          url: "https://www.shoppersdrugmart.ca/en/contact-us/accessibility-standard",
        },
        {
          text: "Terms and Conditions",
          url: "https://corporate.shoppersdrugmart.ca/en/legal",
        },
        {
          text: "Privacy policy",
          url: "https://www.loblaw.ca/en/privacy-policy/",
        },
      ],
      disclaimer: {
        line1:
          "Prices shown online may be different in store. Product availability may vary by store. Please contact your nearest store for availability and quantity limitations. ",
        line2: `®/™ Trademarks of 911979 Alberta Ltd., used under license. © ${new Date().getFullYear()} Shoppers Drug Mart Inc.`,
      },
    },
    fr: {
      signUp: {
        info: {
          title: "Inscrivez-vous et obtenez 10 000 points PC Optimum",
          details:
            "Inscrivez-vous pour recevoir des courriels et des offres par texto et obtenez des points à utiliser lors de votre prochain achat de 40 $ ou plus!",
        },
        cta: {
          displayName: "S’inscrire",
          url: "https://www.shoppersdrugmart.ca/page/sign-up",
        },
      },
      downloadApp: {
        title: "Appli Shoppers Drug Mart",
        appStore: {
          url: "https://apps.apple.com/ca/app/shoppers-drug-mart/id1460588916",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/apple-app-store-fr.svg",
          alt: `Télécharger dans l'App Store`,
        },
        googlePlay: {
          url: "https://play.google.com/store/apps/details?id=com.loblaw.shoppersdrugmart",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/google-play-fr.svg",
          alt: "Disponible sur Google Play",
        },
      },
      socialMediaIcons: [
        {
          name: "facebook",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/facebook.svg",
          alt: "facebook icon",
          url: "https://www.facebook.com/shoppersdrugmart",
        },
        {
          name: "instagram",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/instagram.svg",
          alt: "instagram icon",
          url: "https://www.instagram.com/shoppersdrugmart/",
        },
        {
          name: "pinterest",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/pinterest.svg",
          alt: "pinterest icon",
          url: "https://www.pinterest.ca/shoppersdrugmart/",
        },
        {
          name: "tiktok",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/tiktok.svg",
          alt: "tiktok icon",
          url: "https://www.tiktok.com/@shoppersdrugmart",
        },
        {
          name: "twitter",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/twitter.svg",
          alt: "twitter icon",
          url: "https://twitter.com/ShopprsDrugMart",
        },
        {
          name: "youtube",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/youtube.svg",
          alt: "youtube icon",
          url: "https://www.youtube.com/user/ShoppersDrugMartTV",
        },
      ],
      siteMapLinks: [
        {
          title: "FAQ",
          categories: [
            {
              text: "Magasinage en ligne",
              url: "https://lclcallcenters.my.site.com/shoppersdrugmart/s/topic/0TO2M000001FlqEWAS/online-shopping-services?language=fr",
            },

            {
              text: "PC Optimum",
              url: "https://lclcallcenters.my.site.com/PCoptimumsupport/s/?language=fr",
            },
            {
              text: "Mon tableau de bord Santé",
              url: "https://www.shoppersdrugmart.ca/health/my-health-dashboard?lang=fr",
            },
            {
              text: "Autre FAQ",
              url: "https://lclcallcenters.my.site.com/shoppersdrugmart/s/?language=fr",
            },
          ],
        },
        {
          title: "Service à la clientèle",
          categories: [
            {
              text: " Nous joindre",
              url: "https://www.shoppersdrugmart.ca/page/contact-us",
            },
            {
              text: "Trouver le magasin",
              url: "https://www.shoppersdrugmart.ca/fr/store-locator",
            },
            {
              text: "Retours et échanges",
              url: "https://www.shoppersdrugmart.ca/page/returns-and-exchanges",
            },
            {
              text: "Livraison et manutention",
              url: "https://www.shoppersdrugmart.ca/page/shipping-and-handling",
            },
            {
              text: "Livraison le jour même",
              url: "https://www.shoppersdrugmart.ca/page/same-day-delivery",
            },
            {
              text: "Ramassage en magasin",
              url: "https://www.shoppersdrugmart.ca/page/OnlinePickUp",
            },
          ],
        },
        {
          title: "Notre entreprise",
          categories: [
            {
              text: `Fondation Pharmaprix pour la santé des femmes`,
              url: "https://shoppersfoundation.ca/fr/",
            },

            {
              text: "Notre entreprise",
              url: "https://corporate.shoppersdrugmart.ca/fr/home",
            },
            {
              text: `Nouvelles de l'entreprise`,
              url: "https://corporate.shoppersdrugmart.ca/fr/our-stories",
            },
            {
              text: "Possibilités de franchise",
              url: "https://corporate.shoppersdrugmart.ca/en/careers-franchise",
            },
            {
              text: "Acquisition de pharmacies",
              url: "https://corporate.shoppersdrugmart.ca/en/careers-sell-to-us",
            },
            {
              text: "Carrières",
              url: "https://corporate.shoppersdrugmart.ca/fr/careers-life-at-shoppers",
            },
          ],
        },
        {
          title: "Autres services de Shoppers",
          categories: [
            {
              text: "Vérifier le solde de la carte-cadeau",
              url: "https://wbiprod.storedvalue.com/wbir/clients/shoppersdrugmart?lng=fr",
            },
            {
              text: "PC Santé",
              url: "https://www.pchealth.ca/fr/",
            },
            {
              text: "Shoppers Photo",
              url: "https://www.shoppersphoto.ca/",
            },
            {
              text: "Photos de Passeport",
              url: "https://www.shoppersdrugmart.ca/fr/more-by-shoppers/passport",
            },
            {
              text: "Zone Marché",
              url: "https://www.shoppersdrugmart.ca/fr/more-by-shoppers/fresh-food",
            },
            {
              text: "PRESTO",
              url: "https://www.shoppersdrugmart.ca/fr/more-by-shoppers/presto",
            },
          ],
        },
      ],
      utilityLinks: [
        {
          text: "English",
          url: "https://www.shoppersdrugmart.ca/?lang=en",
        },
        {
          text: "Accessibilité",
          url: "https://www.shoppersdrugmart.ca/fr/contact-us/accessibility-standard",
        },
        {
          text: "Terms et conditions",
          url: "https://corporate.shoppersdrugmart.ca/en/legal",
        },
        {
          text: "Politique de confidentialité",
          url: "https://www.loblaw.ca/fr/privacy-policy/",
        },
      ],

      disclaimer: {
        line1:
          "Les prix indiqués en ligne peuvent être différents en magasin. La disponibilité des produits peut varier selon les magasins. Veuillez contacter votre magasin le plus proche pour connaître les limites de disponibilité et de quantité.",
        line2: `🅪/🅪 Marques de commerce de 911979 Alberta Ltd., utilisées sous licence. © ${new Date().getFullYear()} Pharmaprix Inc.`,
      },
    },
  },
  pharmaprix: {
    en: {
      signUp: {
        info: {
          title: "Sign up and get 10,000 PC Optimum™ points",
          details:
            "Sign up for emails and text offers and get points to use on your next purchase of $40+!",
        },
        cta: {
          displayName: "Sign up",
          url: "https://www.pharmaprix.ca/page/sign-up",
        },
      },
      downloadApp: {
        title: "Pharmaprix App",
        appStore: {
          url: "https://apps.apple.com/ca/app/pharmaprix/id6448917330",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/apple-app-store.svg",
          alt: "Download on the App Store",
        },
        googlePlay: {
          url: "https://play.google.com/store/apps/details?id=com.loblaw.pharmaprix",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/google-play.svg",
          alt: "Get it on Google Play",
        },
      },
      socialMediaIcons: [
        {
          name: "facebook",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/facebook.svg",
          alt: "facebook icon",
          url: "https://www.facebook.com/Pharmaprix",
        },
        {
          name: "instagram",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/instagram.svg",
          alt: "instagram icon",
          url: "https://www.instagram.com/pharmaprix/",
        },
        {
          name: "twitter",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/twitter.svg",
          alt: "twitter icon",
          url: "https://twitter.com/PharmaprixQC",
        },
      ],
      siteMapLinks: [
        {
          title: "FAQ",
          categories: [
            {
              text: "Online Shopping",
              url: "https://lclcallcenters.my.site.com/pharmaprix/s/topic/0TO2M000001Fm2PWAS/achats-et-services-en-ligne?language=en_US",
            },

            {
              text: "PC Optimum™",
              url: "https://lclcallcenters.my.site.com/PCoptimumsupport/s/?language=en_US",
            },
            {
              text: "Online Pharmacy Account",
              url: "https://mondossierpharma.ca/en/Content/Faq",
            },
            {
              text: "Other FAQ",
              url: "https://lclcallcenters.my.site.com/pharmaprix/s/?language=en_US",
            },
          ],
        },
        {
          title: "Customer Service",
          categories: [
            {
              text: "Contact Us",
              url: "https://www.pharmaprix.ca/page/contact-us",
            },
            {
              text: "Find a Store",
              url: "https://www.pharmaprix.ca/en/store-locator",
            },

            {
              text: "Returns & Exchanges",
              url: "https://www.pharmaprix.ca/page/returns-and-exchanges",
            },
            {
              text: "Shipping & Handling",
              url: "https://www.pharmaprix.ca/page/shipping-and-handling",
            },
            {
              text: "Same-day Delivery",
              url: "https://www.pharmaprix.ca/page/same-day-delivery",
            },
          ],
        },
        {
          title: "Corporate",
          categories: [
            {
              text: `Shoppers Foundation for Women’s Health™`,
              url: "https://fondationpharmaprix.ca/en/",
            },

            {
              text: "Corporate",
              url: "https://corporate.shoppersdrugmart.ca/en/home",
            },
            {
              text: "Corporate News",
              url: "https://corporate.shoppersdrugmart.ca/en/our-stories",
            },
            {
              text: "Franchise Opportunities",
              url: "https://corporate.shoppersdrugmart.ca/fr/careers-franchise",
            },
            {
              text: "Pharmacy Acquisitions",
              url: "https://corporate.shoppersdrugmart.ca/fr/careers-sell-to-us",
            },
            {
              text: "Careers",
              url: "https://corporate.shoppersdrugmart.ca/fr/careers-life-at-shoppers",
            },
          ],
        },
        {
          title: "More by Pharmaprix",
          categories: [
            {
              text: "Check Gift Card Balance",
              url: "https://wbiprod.storedvalue.com/wbir/clients/pharmaprix?lng=en",
            },
            {
              text: "PC Health™",
              url: "https://www.pchealth.ca/en/",
            },
            {
              text: "Pharmaprix Photo",
              url: "https://www.pharmaprixphoto.ca/",
            },
            {
              text: "Passport Photos",
              url: "https://www.pharmaprix.ca/en/more-by-pharmaprix/passport",
            },
            {
              text: "Fresh Food",
              url: "https://www.pharmaprix.ca/en/more-by-pharmaprix/fresh-food",
            },
          ],
        },
      ],
      utilityLinks: [
        {
          text: "Français",
          url: "https://www.pharmaprix.ca/?lang=fr",
        },
        {
          text: "Accessibility",
          url: "https://www.pharmaprix.ca/en/contact-us/accessibility-standard",
        },
        {
          text: "Terms and Conditions",
          url: "https://corporate.shoppersdrugmart.ca/fr/legal",
        },
        {
          text: "Privacy policy",
          url: "https://www.loblaw.ca/en/privacy-policy/",
        },
      ],

      disclaimer: {
        line1:
          "Prices shown online may be different in store. Product availability may vary by store. Please contact your nearest store for availability and quantity limitations. ",
        line2: `®/™ Trademarks of 911979 Alberta Ltd., used under license. © ${new Date().getFullYear()} Pharmaprix Inc.`,
      },
    },
    fr: {
      signUp: {
        info: {
          title: "Inscrivez-vous et obtenez 10 000 points PC Optimum",
          details:
            "Inscrivez-vous pour recevoir des courriels et des offres par texto et obtenez des points à utiliser lors de votre prochain achat de 40 $ ou plus!",
        },
        cta: {
          displayName: "S’inscrire",
          url: "https://www.pharmaprix.ca/page/sign-up",
        },
      },
      downloadApp: {
        title: "Appli Pharmaprix ",
        appStore: {
          url: "https://apps.apple.com/ca/app/pharmaprix/id6448917330",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/apple-app-store-fr.svg",
          alt: `Télécharger dans l'App Store`,
        },
        googlePlay: {
          url: "https://play.google.com/store/apps/details?id=com.loblaw.pharmaprix",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/google-play-fr.svg",
          alt: "Disponible sur Google Play",
        },
      },
      socialMediaIcons: [
        {
          name: "facebook",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/facebook.svg",
          alt: "facebook icon",
          url: "https://www.facebook.com/Pharmaprix",
        },
        {
          name: "instagram",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/instagram.svg",
          alt: "instagram icon",
          url: "https://www.instagram.com/pharmaprix/",
        },
        {
          name: "twitter",
          src: "https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-icons/sdui-icons/social-media/twitter.svg",
          alt: "twitter icon",
          url: "https://twitter.com/PharmaprixQC",
        },
      ],
      siteMapLinks: [
        {
          title: "FAQ",
          categories: [
            {
              text: "Magasinage en ligne",
              url: "https://lclcallcenters.my.site.com/pharmaprix/s/topic/0TO2M000001Fm2PWAS/achats-et-services-en-ligne?language=fr",
            },

            {
              text: "PC Optimum",
              url: "https://lclcallcenters.my.site.com/PCoptimumsupport/s/?language=fr",
            },
            {
              text: "Compte de pharmacie en ligne",
              url: "https://mondossierpharma.ca/fr/Content/Faq",
            },
            {
              text: "Autre FAQ",
              url: "https://lclcallcenters.my.site.com/pharmaprix/s/?language=fr",
            },
          ],
        },
        {
          title: "Service à la clientèle",
          categories: [
            {
              text: "Nous joindre",
              url: "https://www.pharmaprix.ca/page/contact-us",
            },
            {
              text: "Trouver le magasin",
              url: "https://www.pharmaprix.ca/fr/store-locator",
            },

            {
              text: "Retours et échanges",
              url: "https://www.pharmaprix.ca/page/returns-and-exchanges",
            },
            {
              text: "Livraison et manutention",
              url: "https://www.pharmaprix.ca/page/shipping-and-handling",
            },
            {
              text: "Livraison le jour même",
              url: "https://www.pharmaprix.ca/page/same-day-delivery",
            },
          ],
        },
        {
          title: "Notre entreprise",
          categories: [
            {
              text: `Fondation Pharmaprix pour la santé des femmes`,
              url: "https://fondationpharmaprix.ca/",
            },

            {
              text: "Notre entreprise",
              url: "https://corporate.shoppersdrugmart.ca/fr/home",
            },
            {
              text: `Nouvelles de l'entreprise`,
              url: "https://corporate.shoppersdrugmart.ca/fr/our-stories",
            },
            {
              text: "Possibilités de franchise",
              url: "https://corporate.shoppersdrugmart.ca/fr/careers-franchise",
            },
            {
              text: "Acquisition de pharmacies",
              url: "https://corporate.shoppersdrugmart.ca/fr/careers-sell-to-us",
            },
            {
              text: "Carrières",
              url: "https://corporate.shoppersdrugmart.ca/fr/careers-life-at-shoppers",
            },
          ],
        },
        {
          title: "Autres services de Pharmaprix ",
          categories: [
            {
              text: "Vérifier le solde de la carte-cadeau",
              url: "https://wbiprod.storedvalue.com/wbir/clients/pharmaprix?lng=fr",
            },
            {
              text: "PC Santé",
              url: "https://www.pchealth.ca/fr/",
            },
            {
              text: "Pharmaprix Photo",
              url: "https://www.pharmaprixphoto.ca/",
            },
            {
              text: "Photos de Passeport",
              url: "https://www.pharmaprix.ca/fr/more-by-pharmaprix/passport",
            },
            {
              text: "Zone Marché",
              url: "https://www.pharmaprix.ca/fr/more-by-pharmaprix/fresh-food",
            },
          ],
        },
      ],
      utilityLinks: [
        {
          text: "English",
          url: "https://www.pharmaprix.ca/?lang=en",
        },
        {
          text: "Accessibilité",
          url: "https://www.pharmaprix.ca/fr/contact-us/accessibility-standard",
        },
        {
          text: "Terms et conditions",
          url: "https://corporate.shoppersdrugmart.ca/fr/legal",
        },
        {
          text: "Politique de confidentialité",
          url: "https://www.loblaw.ca/fr/privacy-policy/",
        },
      ],

      disclaimer: {
        line1:
          "Les prix indiqués en ligne peuvent être différents en magasin. La disponibilité des produits peut varier selon les magasins. Veuillez contacter votre magasin le plus proche pour connaître les limites de disponibilité et de quantité.",
        line2: `🅪/🅪 Marques de commerce de 911979 Alberta Ltd., utilisées sous licence. © ${new Date().getFullYear()} Pharmaprix Inc.`,
      },
    },
  },
};
